import React from 'react'
import { Box } from '@mui/material'
import Anime from '../../../frontend-lib/anime/Anime'

function ScamTop({ className }) {
  return (
    <svg
      className={className}
      width="72"
      height="64"
      viewBox="0 0 72 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.1007 12.3746L1.71561 49.904C-1.49849 55.0621 2.07131 61.7661 8.14516 61.9786L62.8545 63.8921C67.3508 64.0493 71.0706 60.4258 71.0314 55.9269L70.7634 25.2216C70.6948 17.3538 66.8818 9.98944 60.4966 5.39208C48.8995 -2.95778 32.658 0.24616 25.1007 12.3746ZM49.8561 22.3198C49.8561 22.3198 47.8471 23.7483 43.0964 23.7897C38.3456 23.8312 36.312 22.438 36.312 22.438C36.312 22.438 38.2964 18.1878 43.0471 18.1464C47.7978 18.1049 49.8561 22.3198 49.8561 22.3198ZM59.8946 25.4256C63.6744 26.4142 65.369 25.3538 65.369 25.3538C65.369 25.3538 64.0203 20.4905 60.2405 19.502C56.4607 18.5135 54.5931 22.5356 54.5931 22.5356C54.5931 22.5356 56.1148 24.4371 59.8946 25.4256Z"
        fill="#151537"
      />
    </svg>
  )
}

function ScamLeft({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="113"
      height="116"
      viewBox="0 0 113 116"
      fill="none"
    >
      <ellipse
        cx="22.4126"
        cy="17.6942"
        rx="22.4126"
        ry="17.6942"
        transform="matrix(-0.824407 0.565998 0.565998 0.824407 45.8477 37.4316)"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.0739 32.9716L96.7297 33.991C104.104 34.1311 108.566 42.1971 104.766 48.5187L70.5352 105.459C67.7219 110.139 61.5746 111.528 57.0223 108.513L25.9521 87.9359C17.9908 82.6632 13.0179 73.9131 12.5617 64.375C11.7333 47.0517 25.7339 32.6422 43.0739 32.9716ZM36.8245 64.7405C36.8245 64.7405 39.6067 63.6407 42.7905 58.8335C45.9742 54.0264 45.9012 51.0356 45.9012 51.0356C45.9012 51.0356 40.2638 50.2444 37.0801 55.0516C33.8963 59.8588 36.8245 64.7405 36.8245 64.7405ZM33.347 77.0101C31.8535 81.5103 29.6538 82.5337 29.6538 82.5337C29.6538 82.5337 25.5966 77.9452 27.0901 73.445C28.5836 68.9448 33.9117 69.7039 33.9117 69.7039C33.9117 69.7039 34.8405 72.5098 33.347 77.0101Z"
        fill="#151537"
      />
    </svg>
  )
}

function ScamRight({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="110"
      height="111"
      viewBox="0 0 110 111"
      fill="none"
    >
      <ellipse
        cx="76.0359"
        cy="60.0111"
        rx="21.3135"
        ry="16.8265"
        transform="rotate(39.555 76.0359 60.0111)"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.3378 35.4587L16.4281 31.9033C9.43096 31.4146 4.52507 38.6789 7.59212 44.987L35.2182 101.806C37.4886 106.476 43.1944 108.31 47.7605 105.838L78.9246 88.9646C86.9099 84.6411 92.3577 76.7718 93.5934 67.7756C95.8378 51.4365 83.7903 36.6078 67.3378 35.4587ZM70.5804 66.0774C70.5804 66.0774 68.0378 64.8012 65.4271 59.9795C62.8165 55.1578 63.1377 52.331 63.1377 52.331C63.1377 52.331 68.5442 52.0567 71.1548 56.8784C73.7655 61.7001 70.5804 66.0774 70.5804 66.0774ZM72.8406 77.9924C73.8761 82.3809 75.8734 83.5357 75.8734 83.5357C75.8734 83.5357 80.1032 79.5312 79.0677 75.1427C78.0322 70.7542 72.9213 71.0242 72.9213 71.0242C72.9213 71.0242 71.8051 73.6038 72.8406 77.9924Z"
        fill="#151537"
      />
    </svg>
  )
}
function ScamAnimation({ sx, icon, className, initial }) {
  const icons = {
    top: ScamTop,
    left: ScamLeft,
    right: ScamRight,
  }
  const Scam = icons[icon] ?? icons.top
  return (
    <Box sx={{ zIndex: 10, ...sx }}>
      <Anime
        animeConfig={{ loop: true }}
        initial={initial?.map((it) => ({
          targets: `.${className}`,
          ...it,
        }))}
      >
        <Scam className={className} />
      </Anime>
    </Box>
  )
}

export default ScamAnimation
